<app-data-table
  title="Government Account"
  url="users/government"
  type="government"
></app-data-table>
